<template>
    <div class="departmentManager">
        <div class="leftStructure">
            <tree
                ref="tree"
                title="部门信息"
                :treeEdit="true"
                :showCheckbox="false"
                :sourceData="sourceData"
                :formatTreeData="jsonTree"
                :defExpandNode="treeExpandNode"
                @clickTreeNode="clickTree"
                @freshTreeData="getTreeData">
            </tree>
        </div>
        <div class="centerStructure">
            <el-container>
                <el-main>
                    <el-tabs>
                        <el-tab-pane label="部门详情">
                            <div class="parent-node">上级部门：{{ parentLabel }}</div>
                            <el-form
                                :model="departmentForm"
                                :rules="rules"
                                label-width="100px"
                                ref="departmentForm"
                                size="medium">
                                <el-row>
                                    <el-col :span='8'>
                                        <el-form-item label="部门名称：" prop="departmentName">
                                            <el-input 
                                                :disabled="isDisable" 
                                                v-model.trim="departmentForm.departmentName"
                                                placeholder="请输入部门名称">
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span='8'>
                                        <el-form-item label="排序码：" prop="sort">
                                            <el-input 
                                                :disabled="isDisable"
                                                v-model.trim="departmentForm.sort"
                                                placeholder="请输入排序码">
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span='8'>
                                        <el-form-item label="部门编码：" prop="departmentCode">
                                            <el-input 
                                                :disabled="isDisable"
                                                v-model.trim="departmentForm.departmentCode"
                                                placeholder="请输入部门编码">
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span='8'>
                                        <el-form-item label="启用：">
                                            <el-radio-group v-model="departmentForm.depEnable" :disabled="isDisable">
                                                <el-radio :label="true" border>是</el-radio>
                                                <el-radio :label="false" border>否</el-radio>
                                            </el-radio-group>
                                        </el-form-item>

                                    </el-col>
                                    <el-col :span='16'>
                                        <el-form-item label="备注：" prop="remark">
                                            <el-input 
                                                :disabled="isDisable"
                                                v-model.trim="departmentForm.remark" style="width: 513px"
                                                placeholder="请填写备注信息">
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span='8'>
                                        <el-form-item label="创建人：" >
                                            <el-input 
                                                v-model.trim="departmentForm.userName"
                                                disabled>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span='8'>
                                        <el-form-item label="创建时间：" >
                                            <el-date-picker
                                                v-model="departmentForm.createTime"
                                                type="datetime"
                                                disabled
                                                value-format="yyyy-MM-dd HH:mm:ss">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="operation-btn" v-show="isEdit">
                                            <el-button 
                                                type="primary" 
                                                :loading=submitFlag
                                                @click="submitForm('departmentForm')"
                                                size="medium">提 交
                                            </el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-tab-pane>
                    </el-tabs>
                </el-main>
            </el-container>
        </div>
    </div>
</template>

<script>
    import {Mixins} from '@/config/mixins/mixins'
    import {$http} from '@/config/api/axios'
    import Tree from "@/components/common/Tree"
    import {IsNull, timestampToTime} from "@/config/validate/common";

    export default {
        name: 'departmentManager',
        mixins: [Mixins],
        components: {
            Tree,
        },

        data() {
            return {
                sourceData: [],
                jsonTree: {
                    id: "id",
                    label: 'departmentName',
                    pcode: 'parentCode',
                    code: 'code',
                    extra:["depEnable"]
                },
                treeExpandNode:[],
                departmentForm: {
                    id: '',
                    customerId:'',
                    code: '',
                    parentCode: '',
                    departmentCode: '',
                    departmentName: '',
                    depEnable: true,
                    sort: '',
                    remark: '',
                    createTime: '',
                    userName: '',
                },
                rules: {
                    departmentName: [
                        {required: true, message: '请输入部门名称', trigger: 'blur'},
                        {min: 0, max: 20, message: '长度不超过20个汉字或字符', trigger: 'blur'},
                    ],
                    sort: [
                        {required: true, message: '请输入排序码', trigger: 'blur'},
                        {pattern: /^\+?[1-9]{1}[0-9]{0,3}\d{0,0}$/, message: "只允许输入1-9999的数字", trigger: "blur",}
                    ],
                    departmentCode: [
                        {pattern: /^[a-zA-Z0-9]/, message: "只允许输入数字和字母", trigger: "blur"},
                        {min: 0, max: 10, message: '长度不超过10个字符', trigger: 'blur'},
                    ],
                    remark:[
                        {min: 0, max: 100, message: '长度不超过100个字符', trigger: 'blur'},
                    ]
                    
                },
                isDisable: true,
                parentLabel: '无',
                isEdit:false,
                submitFlag: false,
                addNodeId:'',
            }
        },
        methods: {
            //查询部门树
            getTreeData(selectId) {
                this.sourceData = [];
                this.selfLoadingOpen('.departmentManager');
                let param = {
                    isAll: true
                };
                $http("get", "department/listDepartments", param).then((res) => {
                    if(res.status == 'SUCCESS'){
                        this.treeExpandNode = [];
                        if(selectId != null){
                            this.treeExpandNode.push(selectId);
                        }
                        res.data.forEach((item) => {
                            if (item.parentCode === '0.') {
                                item["delIcon"] = false;
                                item["editIcon"] = false;
                                item["addIcon"] = this.$root.$permissionMap.has('insertDepartment');
                            }else{
                                item["delIcon"] = this.$root.$permissionMap.has('deleteDepartment');
                                item["editIcon"] = this.$root.$permissionMap.has('updateDepartment');
                                item["addIcon"] = this.$root.$permissionMap.has('insertDepartment');
                            }
                        });
                        this.sourceData = res.data;
                        this.$refs.tree.filterText = '';
                        if(this.sourceData.length > 0){
                            this.$nextTick(()=>{
                                if(selectId == null){
                                    let firstTreeData = this.$refs.tree.treeData[0];
                                    this.$refs.tree.setCurrentKey(firstTreeData.id);
                                    this.clickTree(firstTreeData);
                                }else{
                                    this.$refs.tree.setCurrentKey(selectId);
                                    let selectData = this.$refs.tree.getCurrentNode();
                                    this.clickTree(selectData);
                                }
                            });
                        }
                    } else {
                        this.sourceData = [];
                    }
                    this.selfLoadingClose();
                });
            },
            //点击树
            clickTree(data) {
                this.$refs.departmentForm.resetFields();
                let id = data.id;
                //查询上级部门
                let tip = this.$refs.tree.getParentLable(id);
                if (tip == "No"){
                  this.parentLabel = "无";
                }else {
                  this.parentLabel = this.$refs.tree.getParentLable(id);
                }
                // 获取右侧部门信息
                $http("get", "department/getDepartmentById", {id}).then((res) => {
                    if (res.status === 'SUCCESS') {
                        let tmp = res.data;
                        this.departmentForm.id = tmp.id;
                        this.departmentForm.customerId = tmp.customerId;
                        this.departmentForm.code = tmp.code;
                        this.departmentForm.parentCode = tmp.parentCode;
                        this.departmentForm.departmentCode = tmp.departmentCode;
                        this.departmentForm.departmentName = tmp.departmentName;
                        this.departmentForm.depEnable = tmp.depEnable;
                        this.departmentForm.sort = tmp.sort;
                        this.departmentForm.remark = tmp.remark;
                        this.departmentForm.createTime = timestampToTime(tmp.createTime);
                        this.departmentForm.userName = tmp.userName;
                    } else {
                        this.msgerror(res.message);
                    }
                });
                this.isEdit = false;
                this.isDisable = true;
            },
            //添加按钮
            treeAddFun(data){
                this.addNodeId = data.id;
                this.$refs.tree.setCurrentKey(data.id);
                if(!data.extra.depEnable){
                    this.clickTree(data);
                    this.msgwarning('当前部门已被禁用，不允许新增子级节点。');
                    return;
                }
                this.parentLabel = data.label;
                
                this.$refs.departmentForm.resetFields();
                this.departmentForm.id = '';
                this.departmentForm.customerId = '';
                this.departmentForm.code = '';
                this.departmentForm.createTime = '';
                this.departmentForm.userName = '';
                this.departmentForm.depEnable = true;
                this.departmentForm.parentCode = data.code;
                this.isEdit = true;
                this.isDisable = false;
            },
            treeEditFun(data){
                this.addNodeId = data.id;
                this.$refs.tree.setCurrentKey(data.id);
                this.clickTree(data);
                 let pId = this.$refs.tree.getParentKey(data.id);
                let pNode = this.$refs.tree.getNode(pId);
                if(!pNode.data.extra.depEnable){
                    this.msgwarning('当前部门父级已被禁用，不允许修改。');
                    return;
                }
                this.isEdit = true;
                this.isDisable = false;
            },
            treeDelFun(data){
                if (data.children && data.children.length > 0) {
                    this.msgwarning("当前节点包含子节点，请先删除子节点。");
                } else {
                    let params = {id: data.id};
                    this.$confirm('删除后不可恢复，确认要删除吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.selfLoadingOpen('.departmentManager');
                        $http("post", "department/deleteDepartment", params).then((res) => {
                            this.selfLoadingClose();
                            if (res.status === 'SUCCESS') {
                                this.msgsuccess(res.message);
                                this.getTreeData();
                            } else {
                                this.msgerror(res.message);
                            }
                        })
                    }).catch(() => {
                    });
                }
            },
            //提交
            submitForm(value) {
                this.$refs[value].validate((valid) => {
                    if (valid) {
                        this.submitFlag = true;
                        let params = {};
                        params.id = this.departmentForm.id;
                        params.customerId = this.departmentForm.customerId;
                        params.departmentName = this.departmentForm.departmentName;
                        params.departmentCode = this.departmentForm.departmentCode;
                        params.depEnable = this.departmentForm.depEnable;
                        params.sort = this.departmentForm.sort;
                        params.remark = this.departmentForm.remark;
                        params.code = this.departmentForm.code;
                        params.parentCode = this.departmentForm.parentCode;
                        if(IsNull(params.id)){
                            //新增
                            $http("post", "department/insertDepartment", params).then((res) => {
                                this.submitFlag = false;
                                if (res.status === 'SUCCESS') {
                                    this.msgsuccess(res.message);
                                    this.getTreeData(this.addNodeId);
                                } else {
                                    this.msgerror(res.message);
                                }
                            });
                        }else{
                            //编辑
                            $http("post", "department/updateDepartment", params).then((res) => {
                                this.submitFlag = false;
                                if(res.status == 'SUCCESS'){
                                    this.msgsuccess(res.message);
                                    this.getTreeData(this.addNodeId);
                                }else{
                                    this.msgerror(res.message);
                                }
                            });
                        }
                    }
                });
            },
        },
        created() {
            this.getTreeData();
        },
        mounted() {
            this.$refs.tree.nodeAdd = (node,data)=>{
                this.treeAddFun(data);
            }
            this.$refs.tree.nodeEdit = (node,data)=>{
                this.treeEditFun(data);
            }
            this.$refs.tree.nodeDel = (node,data)=>{
                this.treeDelFun(data);
            }
        },
    }
</script>

<style lang="less">
    .departmentManager {
        width: 100%;
        height: 100%;
        margin-bottom: 10px;
        display: flex;

        .operation-btn {
            margin-top: 30px;
            text-align: right;
        }

        .parent-node {
            font-size: 14px;
            font-weight: bold;
            color: #555;
            padding: 10px 0;
        }

        .el-col-5 {
            width: 276px;
            margin-right: 40px;
        }

        .sangezi {
            width: 276px;
            margin-left: -14px;
        }

        .el-tabs__content {
            .el-form {
                width: 934px;

                .el-input {
                    width: 200px;
                }
            }
        }

        .centerStructure {
            padding-top: 4px;
        }

        //启用按钮位置
        .el-radio.is-bordered + .el-radio.is-bordered {
            margin-left: 2px;
        }
    }
</style>